import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Header from "components/Header";
import Footer from "components/Footer";
import ScrollToTop from "components/ScrollToTop";
import Loader from "components/Loader";
import NotFound from "pages/NotFound";
import PrivateRoute from "pages/Dashboard/PrivateRoute";
const PrivacyPolicy = lazy(() => import("pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("pages/TermsOfUse"));
const Home = lazy(() => import("pages/Home"));
const About = lazy(() => import("pages/About"));
const Services = lazy(() => import("pages/Services"));
const Careers = lazy(() => import("pages/Careers"));
const Contact = lazy(() => import("pages/Contact"));
const Learning = lazy(() => import("pages/Learning"));
const DashboardLogin = lazy(() => import("pages/Dashboard/Login"));
const DashboardLayout = lazy(() => import("pages/Dashboard/Layout"));
const DashboardContacts = lazy(() => import("pages/Dashboard/pages/Contacts"));
const DashboardApplications = lazy(() => import("pages/Dashboard/pages/Applications"));
const DashboardEnrollments = lazy(() => import("pages/Dashboard/pages/Enrollments"));
const DashboardJobs = lazy(() => import("pages/Dashboard/pages/Jobs"));

function PublicShell() {
  return (
    <>
      <Header />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}

function Routers() {
  return (
    <Suspense fallback={<Loader loading={true} type="Scale" />}>
      <BrowserRouter>
        <Routes>
          {/* Dashboard routes — no Header/Footer */}
          <Route path="/dashboard/login" element={<DashboardLogin />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<DashboardContacts />} />
            <Route path="contacts" element={<DashboardContacts />} />
            <Route path="applications" element={<DashboardApplications />} />
            <Route path="enrollments" element={<DashboardEnrollments />} />
            <Route path="jobs" element={<DashboardJobs />} />
          </Route>

          {/* Public routes — with Header/Footer */}
          <Route element={<PublicShell />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/learning" element={<Learning />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export default Routers;
